import { MenuItem, ListItemText, ListSubheader, Tooltip, MenuItemProps } from "@mui/material";

import { AvailabilityTypeEnum, CalendarBlockBlockTypeEnum } from "~/graphql/__generated__/graphql";
import { BlockTypes } from "~/components/command/AddToCalendarMenu";

type MenuItemsProps = {
  handleMenuClick: (type: AvailabilityTypeEnum, blockType?: CalendarBlockBlockTypeEnum) => void,
  sx?: MenuItemProps["sx"],
}

const AddAvailabilityMenu = ({ handleMenuClick, sx }: MenuItemsProps) => {
  return <>
    <Tooltip
      title="Add a recurring shift"
      arrow
      placement="right"
    >
      <MenuItem sx={sx} onClick={() => handleMenuClick(AvailabilityTypeEnum.Available)}>
        <ListItemText>Availability</ListItemText>
      </MenuItem>
    </Tooltip>

    <Tooltip
      title="Add time away from work, where no shifts will occur"
      arrow
      placement="right"
    >
      <MenuItem sx={sx} onClick={() => handleMenuClick(AvailabilityTypeEnum.Unavailable)}>
        <ListItemText>Time Off</ListItemText>
      </MenuItem>
    </Tooltip>

    <ListSubheader sx={{ ...sx, minWidth: 170, cursor: "default" }}>Block off time for</ListSubheader>
    <BlockTypes sx={sx} onClick={(blockType) => handleMenuClick(AvailabilityTypeEnum.CalendarBlock, blockType)}/>
  </>
}

export default AddAvailabilityMenu
